<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-contact-reasons-detail-metric-analysis-transcripts">
    <div class="transcript-panel-wrapper">
      <div class="transcript-header">Transcripts</div>
      <div class="transcript-body" v-loading="transcriptLoading">
        <div class="search-header" ref="searchFilters">
          <div @mouseover="onSearchHover" @mouseout="onSearchLeave"  class="search-input-wrapper">
            <el-tooltip :disabled="!isShowAdvancedFilterResultsTooltip" slot="reference" :visible-arrow="false" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
              <div slot="content" ref="advancedFilterHoverSlot"></div>
              
              <el-input 
                v-if="!isSearchInputDisabled &&  (!isShowGroups || searchType == '2')"
                ref="searchInput" 
                class="search-input-field" 
                placeholder="Search transcripts" 
                v-model="advancedFilterPayload.groupA.conditions[0].value"
                @focus="onSearchFocus" 
                @blur="onSearchBlur" 
                @keypress.enter.native="handleEnterSearch"
              >
                <template #prefix>
                  <div>
                    <div class="search-icon">searchIcon</div>
                  </div>
                </template>
                <template #suffix>
                  <div class="el-tooltip-wrapper">
                    <el-tooltip 
                      v-if="searchText&&searchText!=''" slot="reference" content="Clear" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom"
                    >
                      <div  @click="clearSearchInput" class="search-input-field-clear"></div>
                    </el-tooltip>
                  </div>
                </template>
              </el-input>

              <el-input 
                v-else
                ref="searchInput" 
                class="search-input-field" 
                :disabled="true"
                @focus="onSearchFocus" 
                @blur="onSearchBlur" 
                @keypress.enter.native="handleEnterSearch"
              >
                <template #prefix>
                  <div>
                    <div class="search-icon">searchIcon</div>
                  </div>
                </template>
                <template #suffix>
                  <div class="el-tooltip-wrapper">
                    <el-tooltip v-if="searchText&&searchText!=''" slot="reference" content="Clear" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
                      <div @click="clearSearchInput" class="search-input-field-clear"></div>
                    </el-tooltip>
                  </div>
                </template>
              </el-input>

            </el-tooltip>
            <el-popover transition="" @hide="handleEventsOutsideOfPopover" v-model="showAdvancedSearchFilter" placement="bottom-end" popper-class="advanced-metric-wrapper">
              <el-tooltip slot="reference" ref="advancedSearchTooltip" content="Show search options" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
                <div @mouseover="onSearchHover" @mouseout="onSearchLeave" @click="handleHideAdvancedFilterIconTooltip" class="advanced-search-icon"></div>
              </el-tooltip>
              <div class="wy-analytics-transcript-search-dropdown-menu search-input">
                <div class="heading">
                  <div>Advanced Search Options</div>
                  <img style="padding-left: 40px; cursor: pointer" src="../../assets/icons/icon_transcript_close.svg" @click="handleCancelAdvancedSearch">
                </div>
                <div class="divider"/>
                <div class="body" ref="advancedFilterBody">
                  <div class="main-search-dropdown">
                    <div class="sub-heading">
                      Search using:
                    </div>
                    <div class="sub-items">
                      <el-select 
                        ref="searchByDropdown" 
                        v-model="searchType"
                        popper-class="transcript-search-advanced-search-dropdown" 
                        :placeholder="searchTypeList[0].label"
                      >
                        <el-option
                          v-for="item in searchTypeList"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                          :disabled="item.disabled"
                          :selected="item.key === searchTypeList[0].key"
                          >
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <!-- Find Results With Body (Only visible when searchType == '1') -->
                  <div v-if="searchType == '1'">
                    <div class="border"></div>
      
                    <div>
                      <!-- <div class="sub-heading" :class="{'disabled': searchType === '2'}"> -->
                      <div class="sub-heading">
                        Find results with:
                      </div>
      
                      <div v-if="!isShowGroups" class="sub-items results-wrapper">   
                                <div class="dropdown-wrapper">
                              <el-select
                                ref="searchTypeDropdown-0" 
                                :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].searchType}"
                                v-model="advancedFilterPayload.groupA.conditions[0].searchType"                              
                                popper-class="transcript-search-advanced-search-dropdown" 
                                placeholder="By: Search type"
                              >
                                <el-option
                                  v-for="item in searchForList"
                                  :key="item.key"
                                  :label="item.label"
                                  :value="item.key"
                                  :disabled="item.disabled"
                                  >
                                </el-option>
                              </el-select>
                            </div>                     
                            
                            <div class="dropdown-wrapper">
                              <el-dropdown 
                                trigger="click"
                                placement="bottom-start"
                                class="select-box"
                                :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].messageType.length}"
                                @visible-change="handleDefaultMessageTypeDropdownVisibleChange"
                              >
                                <span 
                                  class="value-box" 
                                  :class="{
                                    'placeholder-text': !advancedFilterPayload.groupA.conditions[0].messageType.length,
                                    'value-text': advancedFilterPayload.groupA.conditions[0].messageType.length
                                  }"
                                >
                                {{ handleMessageTypeText(advancedFilterPayload.groupA.conditions[0]) }}
                                <div class="icon-placement-default">
                                  <i class="el-icon-arrow-down el-icon--right placement"></i>
                                </div>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                  <el-checkbox-group 
                                    v-model="advancedFilterPayload.groupA.conditions[0].messageType"
                                    class="message-type-dropdown"
                                    >
                                    <el-checkbox
                                      v-for="item in searchInList"
                                      class="checkbox"
                                      :key="item.key"
                                      :label="item.apiField"
                                      :disabled="item.disabled"
                                    >
                                      {{ item.label }}
                                    </el-checkbox>
                                  </el-checkbox-group> 
                                </el-dropdown-menu>
                              </el-dropdown>
                            </div>
      
                            <div class="search-wrapper" :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].value}">
                              <el-input
                                :class="{'selected-blue remove-border': advancedFilterPayload.groupA.conditions[0].value}"
                                ref="searchForInput"
                                class="search-for-inp"
                                placeholder="For: Keyword/Phrase"
                                v-model="advancedFilterPayload.groupA.conditions[0].value"                              
                              ></el-input>
                            </div>
                          </div>
                      
                      <!-- Group A -->
                      <div v-if="isShowGroups && advancedFilterPayload.groupA" class="group-wrapper">
                        <div>A</div>
      
                        <div class="group">
      
                          <div class="sub-items results-wrapper">
                            <div class="operator-wrapper">                
                              <el-select 
                                ref="innerGroupOperatorDropdown-A"
                                class="selected-blue"
                                v-model="advancedFilterPayload.groupA.operator"                              
                                popper-class="transcript-search-advanced-search-dropdown" 
                              >
                                <el-option
                                  v-for="item in operatorsEnum"
                                  :key="item.key" 
                                  :label="item.label"
                                  :value="item.key"
                                  :disabled="item.disabled"
                                  >
                                </el-option>
                              </el-select>
                            </div>
                            <div>Will apply to each line in this group</div>
                          </div>
      
                          <div class="sub-items">   
                            <div v-for="(condition, index) in advancedFilterPayload.groupA.conditions" :key="index" class="results-wrapper">
                              <div class="dropdown-wrapper">
                                <el-select
                                  :ref="'searchTypeDropdown-'+index" 
                                  :class="{'selected-blue': condition.searchType}"
                                  v-model="condition.searchType"                              
                                  popper-class="transcript-search-advanced-search-dropdown" 
                                  placeholder="By: Search type"
                                >
                                  <el-option
                                    v-for="item in searchForList"
                                    :key="item.key" 
                                    :label="item.label"
                                    :value="item.key"
                                    :disabled="item.disabled"
                                    >
                                  </el-option>
                                </el-select>
                              </div>
            
                              <div class="dropdown-wrapper" >
                                <el-dropdown 
                                  :ref="'messageTypeDropdown-'+index"
                                  trigger="click"
                                  placement="bottom-start"
                                  class="select-box"
                                  :class="{'selected-blue': condition.messageType.length}"
                                  @visible-change="(val) => handleGroupMessageTypeDropdownVisibleChange(val, index)"
                                >
                                  <span 
                                    class="value-box" 
                                    :class="{
                                      'placeholder-text': !condition.messageType.length,
                                      'value-text': condition.messageType.length
                                    }"
                                  >
                                  {{ handleMessageTypeText(condition) }}
                                  <div class="icon-placement-group">
                                    <i class="el-icon-arrow-down el-icon--right" :class="'group-placement-'+index"></i>
                                  </div>
                                  </span>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-checkbox-group 
                                      v-model="condition.messageType"
                                      class="message-type-dropdown"
                                      >
                                      <el-checkbox
                                        v-for="item in searchInList"
                                        class="checkbox"
                                        :key="item.key"
                                        :label="item.apiField"
                                        :disabled="item.disabled"
                                      >
                                        {{ item.label }}
                                      </el-checkbox>
                                    </el-checkbox-group> 
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>
            
                              <div class="search-wrapper" :class="{'selected-blue': condition.value}">
                                <el-input
                                  :class="{'selected-blue remove-border': condition.value}"
                                  ref="searchForInput"
                                  class="search-for-inp"
                                  placeholder="For: Keyword/Phrase"
                                  v-model="condition.value"                              
                                ></el-input>
                              </div>
                              
                              <div v-if="index==0" class="action-btn garbage-wrapper"></div>
                              <el-button v-else class="action-btn garbage-wrapper" @click="handleDeleteCondition('groupA', condition)">
                                <div class="grey-trash-icon"></div>
                              </el-button>
                            </div>   
      
                          </div>
        
                          <div class="search-condition-group sub-actions">
                            <el-button 
                              v-if="!isAdvancedSearchConditionsMaxed" 
                              @click="handleAddCondition('groupA')"
                              class="action-btn" 
                            >
                              <div class=btn-body>
                                <div class="blue-plus-icon" ></div>
                                <div>Add condition</div>
                              </div>
                            </el-button>
                            <el-button class="action-btn" @click="handleDeleteGroup('groupA')">
                              <div class=btn-body>
                                <div class="blue-trash-icon"></div>
                                <div>Delete group</div>
                              </div>
                            </el-button>
                          </div>
                        </div>
                      </div>
      
                      <!-- Group A-B Operator -->
                      <div v-if="advancedFilterPayload.groupA && advancedFilterPayload.groupB" class="group-operator">
                        <el-select 
                          ref="outerGroupOperatorDropdown-B"
                          :class="{'selected-blue': advancedFilterPayload.groupOperators.groupBOperator}"
                          v-model="advancedFilterPayload.groupOperators.groupBOperator"
                          popper-class="transcript-search-advanced-search-dropdown" 
                          placeholder="Condition"
                        >
                          <el-option
                            v-for="item in operatorsEnumBetweenGroup"
                            :key="item.key" 
                            :label="item.label"
                            :value="item.key"
                            :disabled="item.disabled"
                            >
                          </el-option>
                        </el-select>
                      </div>
      
                      <!-- Group B -->
                      <div v-if="advancedFilterPayload.groupB" class="group-wrapper">
                        <div>B</div>
      
                        <div class="group">
      
                          <div class="sub-items results-wrapper">
                            <div class="operator-wrapper">                
                              <el-select 
                                ref="innerGroupOperatorDropdown-B"
                                class="selected-blue"
                                v-model="advancedFilterPayload.groupB.operator"                              
                                popper-class="transcript-search-advanced-search-dropdown" 
                              >
                                <el-option
                                  v-for="item in operatorsEnum"
                                  :key="item.key" 
                                  :label="item.label"
                                  :value="item.key"
                                  :disabled="item.disabled"
                                  >
                                </el-option>
                              </el-select>
                            </div>
                            <div>Will apply to each line in this group</div>
                          </div>
      
                          <div class="sub-items">     
                            <div v-for="(condition, index) in advancedFilterPayload.groupB.conditions" :key="index" class="results-wrapper">
                              <!--@focus="onSearchForFocus"
                                  @blur="onSearchForBlur" -->
                              <div class="dropdown-wrapper">
                                <el-select 
                                  :ref="'searchTypeDropdown-'+(index+20)" 
                                  :class="{'selected-blue': condition.searchType}"
                                  v-model="condition.searchType"                              
                                  popper-class="transcript-search-advanced-search-dropdown" 
                                  placeholder="By: Search type"
                                >
                                  <el-option
                                    v-for="item in searchForList"
                                    :key="item.key" 
                                    :label="item.label"
                                    :value="item.key"
                                    :disabled="item.disabled"
                                    >
                                  </el-option>
                                </el-select>
                              </div>
                              
                              <div class="dropdown-wrapper">
                                <el-dropdown 
                                  :ref="'messageTypeDropdown-'+(index+20)"
                                  trigger="click"
                                  placement="bottom-start"
                                  class="select-box"
                                  :class="{'selected-blue': condition.messageType.length}"
                                  @visible-change="(val) => handleGroupMessageTypeDropdownVisibleChange(val, index+20)"
                                >
                                  <span 
                                    class="value-box" 
                                    :class="{
                                      'placeholder-text': !condition.messageType.length,
                                      'value-text': condition.messageType.length
                                    }"
                                  >
                                  {{ handleMessageTypeText(condition) }}
                                  <div class="icon-placement-group">
                                    <i class="el-icon-arrow-down el-icon--right" :class="'group-placement-' + (index + 20)"></i>
                                  </div>
                                  </span>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-checkbox-group 
                                      v-model="condition.messageType"
                                      class="message-type-dropdown"
                                      >
                                      <el-checkbox
                                        v-for="item in searchInList"
                                        class="checkbox"
                                        :key="item.key"
                                        :label="item.apiField"
                                        :disabled="item.disabled"
                                      >
                                        {{ item.label }}
                                      </el-checkbox>
                                    </el-checkbox-group> 
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>
            
                              <div class="search-wrapper" :class="{'selected-blue': condition.value}">
                                <el-input
                                  :class="{'selected-blue remove-border': condition.value}"
                                  ref="searchForInput"
                                  class="search-for-inp"
                                  placeholder="For: Keyword/Phrase"
                                  v-model="condition.value"                              
                                ></el-input>
                              </div>
      
                              
                              <el-button v-if="index==0" class="action-btn garbage-wrapper" @click="handleDeleteGroup('groupB')">
                                <div class="grey-trash-icon"></div>
                              </el-button>                        
                              <el-button v-else class="action-btn garbage-wrapper" @click="handleDeleteCondition('groupB', condition)">
                                <div class="grey-trash-icon"></div>
                              </el-button>
                            </div>               
                          </div>
        
                          <div class="search-condition-group sub-actions">
                            <el-button 
                              v-if="!isAdvancedSearchConditionsMaxed" 
                              @click="handleAddCondition('groupB')"
                              class="action-btn" 
                            >
                              <div class=btn-body>
                                <div class="blue-plus-icon"></div>
                                <div>Add condition</div>
                              </div>
                            </el-button>
                            <el-button class="action-btn" @click="handleDeleteGroup('groupB')">
                              <div class=btn-body>
                                <div class="blue-trash-icon"></div>
                                <div>Delete group</div>
                              </div>
                            </el-button>
                          </div>
                        </div>
                      </div>
      
                      <!-- Group B-C Operator -->
                      <div v-if="advancedFilterPayload.groupB && advancedFilterPayload.groupC" class="group-operator">
                        <el-select 
                          ref="outerGroupOperatorDropdown-C"
                          :class="{'selected-blue': advancedFilterPayload.groupOperators.groupCOperator}"
                          placeholder="Condition"
                          v-model="advancedFilterPayload.groupOperators.groupCOperator"
                          popper-class="transcript-search-advanced-search-dropdown" 
                        >
                          <el-option
                            v-for="item in operatorsEnumBetweenGroup"
                            :key="item.key" 
                            :label="item.label"
                            :value="item.key"
                            :disabled="item.disabled"
                            >
                          </el-option>
                        </el-select>
                      </div>
      
                      <!-- Group C -->
                      <div v-if="advancedFilterPayload.groupC" class="group-wrapper">
                        <div>C</div>
      
                        <div class="group">
      
                          <div class="sub-items results-wrapper">
                            <div class="operator-wrapper">                
                              <el-select 
                                ref="innerGroupOperatorDropdown-C"
                                class="selected-blue"
                                v-model="advancedFilterPayload.groupC.operator"                          
                                popper-class="transcript-search-advanced-search-dropdown" 
                              >
                                <el-option
                                  v-for="item in operatorsEnum"
                                  :key="item.key" 
                                  :label="item.label"
                                  :value="item.key"
                                  :disabled="item.disabled"
                                  >
                                </el-option>
                              </el-select>
                            </div>
                            <div>Will apply to each line in this group</div>
                          </div>
      
                          <div class="sub-items">  
                            <div v-for="(condition, index) in advancedFilterPayload.groupC.conditions" :key="index" class="results-wrapper">
                              <!--@focus="onSearchForFocus"
                                  @blur="onSearchForBlur" -->
                              <div class="dropdown-wrapper">
                                <el-select 
                                  :ref="'searchTypeDropdown-'+(index+40)" 
                                  :class="{'selected-blue': condition.searchType}"
                                  v-model="condition.searchType"                              
                                  popper-class="transcript-search-advanced-search-dropdown" 
                                  placeholder="By: Search type"
                                >
                                  <el-option
                                    v-for="item in searchForList"
                                    :key="item.key" 
                                    :label="item.label"
                                    :value="item.key"
                                    :disabled="item.disabled"
                                    >
                                  </el-option>
                                </el-select>
                              </div>
            
                              <div class="dropdown-wrapper">
                                <el-dropdown 
                                  :ref="'messageTypeDropdown-'+(index+40)"
                                  trigger="click"
                                  placement="bottom-start"
                                  class="select-box"
                                  :class="{'selected-blue': condition.messageType.length}"
                                  @visible-change="(val) => handleGroupMessageTypeDropdownVisibleChange(val, index+40)"
                                >
                                  <span 
                                    class="value-box" 
                                    :class="{
                                      'placeholder-text': !condition.messageType.length,
                                      'value-text': condition.messageType.length
                                    }"
                                  >
                                  {{ handleMessageTypeText(condition) }}
                                  <div class="icon-placement-group">
                                    <i class="el-icon-arrow-down el-icon--right" :class="'group-placement-' + (index + 40)"></i>
                                  </div>
                                  </span>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-checkbox-group 
                                      v-model="condition.messageType"
                                      class="message-type-dropdown"
                                      >
                                      <el-checkbox
                                        v-for="item in searchInList"
                                        class="checkbox"
                                        :key="item.key"
                                        :label="item.apiField"
                                        :disabled="item.disabled"
                                      >
                                        {{ item.label }}
                                      </el-checkbox>
                                    </el-checkbox-group> 
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>
            
                              <div class="search-wrapper" :class="{'selected-blue': condition.value}">
                                <el-input
                                  :class="{'selected-blue remove-border': condition.value}"
                                  ref="searchForInput"
                                  class="search-for-inp"
                                  placeholder="For: Keyword/Phrase"
                                  v-model="condition.value"
                                ></el-input>
                              </div>
        
                              <el-button v-if="index==0" class="action-btn garbage-wrapper" @click="handleDeleteGroup('groupC')">
                                <div class="grey-trash-icon"></div>
                              </el-button>
                              <el-button v-else class="action-btn garbage-wrapper" @click="handleDeleteCondition('groupC', condition)">
                                <div class="grey-trash-icon"></div>
                              </el-button>
                            </div>                  
                          </div>
        
                          <div class="search-condition-group sub-actions">
                            <el-button 
                              v-if="!isAdvancedSearchConditionsMaxed"
                              @click="handleAddCondition('groupC')"
                              class="action-btn" 
                            >
                              <div class=btn-body>
                                <div class="blue-plus-icon" ></div>
                                <div>Add condition</div>
                              </div>
                            </el-button>
                            <el-button class="action-btn" @click="handleDeleteGroup('groupC')">
                              <div class=btn-body>
                                <div class="blue-trash-icon"></div>
                                <div>Delete group</div>
                              </div>
                            </el-button>
                          </div>
                        </div>
                      </div>

                      <div v-if="advancedFilterPayload.groupC || isAdvancedSearchConditionsMaxed" class="max-constraints-wrapper">
                        <b v-if="advancedFilterPayload.groupC && isAdvancedSearchConditionsMaxed">Max number of conditions and groups reached.</b>
                        <b v-else-if="advancedFilterPayload.groupC">Max number of groups reached.</b>
                        <b v-else-if="isAdvancedSearchConditionsMaxed">Max number of conditions reached.</b>
                      </div>
      
      
                    </div>
      
                    <div class="search-condition-group">
                      <el-button v-if="!isShowGroups" class="action-btn" @click="handleAddMainCondition">
                        <div class=btn-body>
                          <div class="blue-plus-icon"></div>
                          <div>Add condition</div>
                        </div>
                      </el-button>
                      <el-button v-if="!advancedFilterPayload.groupC && !isAdvancedSearchConditionsMaxed" class="action-btn" @click="handleAddMainGroup">
                        <div class=btn-body>
                          <div class="blue-plus-icon"></div>
                          <div>{{ isShowGroups ? 'Add group' : 'Start group' }}</div>
                        </div>
                      </el-button>
                    </div>
                  </div>
                  <div v-else-if="searchType == '2'">
                    <div class="border"></div>
                    <div class="sub-items results-wrapper conversation-id">  
                      <div class="search-wrapper" :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].value}" >
                        <el-input
                          :class="{'selected-blue remove-border': advancedFilterPayload.groupA.conditions[0].value}"
                          ref="searchForInput"
                          class="search-for-inp"
                          placeholder="Conversation ID"
                          v-model="advancedFilterPayload.groupA.conditions[0].value"                              
                        ></el-input>
                      </div>
                    </div>
                    <div v-if="showWarningMsgForKeywordSearch" class="sub-items results-wrapper">  
                      <b>Please note: </b>Applying this search will remove the previously applied Keyword/Phrase search
                    </div>  
                  </div>

                </div>
                <div class="divider" />
                <div class="footer">
                  <el-button plain class="actions-btn reset" @click="handleResetAllAdvancedSearch"><span>Reset all</span></el-button>
                  <div v-if="isShowGroups && searchType != '2'">
                    <b>Search summary: </b>
                    {{ advancedFilterPayload.groupC ? "(": "" }}{{ advancedFilterPayload.groupA ? "GroupA" : "" }} 
                      {{ advancedFilterPayload.groupOperators.groupBOperator 
                        ? operatorsEnum.find((en) => en.key == advancedFilterPayload.groupOperators.groupBOperator).label 
                        : advancedFilterPayload.groupB ? "[Select Condition]" : ""
                      }} 
                    {{ advancedFilterPayload.groupB ? "GroupB" : "" }}{{ advancedFilterPayload.groupC ? ")": "" }}
                      {{ advancedFilterPayload.groupOperators.groupCOperator 
                        ? operatorsEnum.find(en => en.key == advancedFilterPayload.groupOperators.groupCOperator).label 
                        : advancedFilterPayload.groupC ? "[Select Condition]" : ""
                      }} 
                    {{ advancedFilterPayload.groupC ? "GroupC" : "" }}

                  </div>
                  <div class="actions">
                    <el-button plain class="actions-btn clear-btn" @click="handleCancelAdvancedSearch"><span class="">Cancel</span></el-button>
                    <el-button plain class="actions-btn apply-btn" @click="handleApplyAdvancedSearch" :disabled="isAdvancedSearchApplyDisabled"><span class="">Apply</span></el-button>
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
          <div class="transcript-filters-wrapper" v-if="activeSubPage">
            <div class="saved-transcript-wrapper" v-if="activeSubPage === 'experience'">
              <div class="view-saved-transcript" :class="{ selected: savedTranscriptResultBes }" @click="toggleSavedTranscriptFilter">
                <div class="golden-star-icon"></div>
                <span>Saved</span>
              </div>
            </div>

            <div class="saved-transcript-wrapper" v-if="activeSubPage === 'automation'">
              <div class="view-saved-transcript" :class="{ selected: savedTranscriptResultBas }" @click="toggleSavedTranscriptFilter">
                <div class="golden-star-icon"></div>
                <span>Saved</span>
              </div>
            </div>

            <div class="filter-dropdown-wrapper">
              <el-dropdown
                v-for="(dropdown, index) in transcriptDropdowns"
                ref="dropdown"
                placement="bottom-start"
                :key="index"
                :hide-on-click="false"
                trigger="click"
                @visible-change="(visible) => handleTranscriptDropdownState(dropdown, visible)"
                @command="(command) => handleTranscriptDropdownCommand(command, dropdown)"
              >
                <div :style="{ display: dropdown.show ? 'block' : 'none' }">
                  <div
                    class="dropdown-element"
                    :class="{ active: dropdown.opened, selected: dropdown.selectedOptions.length }"
                    @click="toggleTranscriptDropdown(dropdown)"
                    @mousedown="(e) => e.preventDefault()"
                  >
                    <span class="dropdown-title">
                      <span>{{ dropdown.title }}</span>
                      <div :class="{ 'arrow-up': dropdown.opened, 'arrow-down': !dropdown.opened, remove: dropdown.selectedOptions.length }" @click="handleRemoveTranscriptFilter(dropdown)"></div>
                    </span>
                  </div>

                  <el-dropdown-menu class="dropdown-content-wrapper" slot="dropdown" v-show="dropdown.opened">
                    <div class="dropdown-content-header">
                      <div>{{ dropdown.title }}</div>
                      <el-dropdown-item class="close-icon" command="close"></el-dropdown-item>
                    </div>
                    <div class="dropdown-content-checkbox-wrapper">
                      <el-checkbox-group class="dropdown-content-checkbox-group" v-model="dropdown.selectedOptions">
                        <el-checkbox v-for="(option, index) in dropdown.options" :key="index" :label="option.label" v-model="option.checked" @change="handleOptionChange(dropdown, option.label)">
                          <div class="flex-signal">
                            <span class="dropdown-content-label">{{ option.label }}</span>
                            <el-tooltip effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom" :content="option.tooltipContent">
                              <img class="signal-icon" src="../../assets/icons/icon_info.svg" />
                            </el-tooltip>
                          </div>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="dropdown-content-footer" :style="{ justifyContent: dropdown.showFilterReset ? 'space-between' : 'flex-end' }">
                      <el-dropdown-item v-if="dropdown.showFilterReset" command="reset" class="btn reset">Reset all</el-dropdown-item>
                      <div class="btn-wrapper">
                        <el-dropdown-item command="close" class="btn cancel">Cancel</el-dropdown-item>
                        <el-dropdown-item command="applySearch" class="btn apply">Apply</el-dropdown-item>
                      </div>
                    </div>
                  </el-dropdown-menu>
                </div>
              </el-dropdown>
            </div>
          </div>
        </div>
        <wy-transcript-search-results ref="transcriptSearchResults" :controller="module" :contactReason="topicDisplayName" @handle-transcript-click="handleTranscriptExpand" from="metricAnalysis" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import WyTranscriptSearchResults from './wy-analytics-transcript-search-results.vue';
import { mapActions, mapGetters } from 'vuex';
import { TabNameEnum, DropdownOptionsEnum } from './wy-analytics-contact-reasons-detail-metric-analysis.vue';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-detail-metric-analysis-transcripts',
  props: ['parent', 'transcriptData', 'tableData', 'topicDisplayName', 'activeSubPage'],
  components: {
    'wy-transcript-search-results': WyTranscriptSearchResults,
  },

  data() {
    return {
      module: this,
      visible: false,
      transcriptLoading: false,
      transcriptIconType: 'new',
      isTranscriptExpanded: false,
      localFilterMap: {},

      searchText: null,
      
      //OC-1883 Advanced Search Filter
      showAdvancedSearchFilter: false,
      operatorsEnum: [
        {key: '1', label: 'AND', disabled: false},
        {key: '2', label: 'OR', disabled: false},
        {key: '3', label: 'NOT AND', disabled: false},
        {key: '4', label: 'NOT OR', disabled: false}
      ],
      operatorsEnumBetweenGroup: [
        {key: '1', label: 'AND', disabled: false},
        {key: '2', label: 'OR', disabled: false}
        
      ],
      isShowGroups: false,
      isSearchInputDisabled: false,
      // used to updating groupA.condition[0] when searchText exists and enter pressed
      isInitialUpdateAdvancedFilter: false, 
      // used for copying behavior for clicking reset all and clicking outside of popover
      isAdvancedFilterReset: false,
      advancedFilterPayload: {
        groupOperators: {
          groupBOperator: null,
          groupCOperator: null
        },
        groupA: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }]
        },
      },
      isShowAdvancedFilterResultsTooltip: false,
      MAX_TOTAL_CONDITIONS: 15,
      allowed_groups: ['groupA', 'groupB', 'groupC'],

      // Search By
      searchType: '1',
      searchTypeList: [
        {key: '1', label: 'Keyword/Phrase', disabled: false},
        {key: '2', label: 'Conversation ID', disabled: false}
      ],
      // Search For
      searchFor: '1',
      searchForList: [
        {key: '1', label: 'Exact match', disabled: false},
        {key: '2', label: 'Contains', disabled: false},
      ],
      // Search In
      searchIn: [],
      searchInList: [
        {key: '1', label: 'Customer messages', apiField: 'Customer', disabled: false, checked: true},
        {key: '2', label: 'Virtual Agent messages', apiField: 'Bot', disabled: false, checked: true},
        {key: '3', label: 'Live Agent messages', apiField: 'Agent', disabled: false, checked: true},
      ],

      savedTranscriptResultBes: false,
      savedTranscriptResultBas: false,
      transcriptDropdowns: [
        {
          title: DropdownOptionsEnum.BES,
          options: [
            { label: 'Bot Repetition', checked: false, tooltipContent: 'The virtual agent repeats itself within 3 consecutive messages during a conversation.' },
            { label: 'User Abandoned', checked: false, tooltipContent: 'The customer drops off from a conversation without reaching a legitimate end response configured on the bot.' },
            {
              label: 'Negative Sentiment',
              checked: false,
              tooltipContent: 'AI-detected sentiment from the latter half of virtual agent conversations, where at least three user messages are received.',
            },
            { label: 'Repeated Escalation Requests', checked: false, tooltipContent: 'The customer requests to be escalated multiple times within a conversation.' },
            { label: 'Negative Feedback', checked: false, tooltipContent: 'The customer provides explicit negative feedback in a conversation.' },
            { label: 'Profanity', checked: false, tooltipContent: 'Profanity detected in customer messages within a conversation.' },
            { label: 'User Paraphrases', checked: false, tooltipContent: 'The customer uses a similar query twice or more within a conversation.' },
          ],
          selectAll: false,
          selectedOptions: [],
          initialSelectedOptions: [],
          opened: false,
          show: this.activeSubPage && this.activeSubPage === TabNameEnum.EXPERIENCE,
          showFilterReset: false,
          isReset: false,
        },
        {
          title: DropdownOptionsEnum.BAS,
          options: [
            { label: 'Escalation', checked: false, tooltipContent: 'The customer is escalated or handed off to an agent.' },
            { label: 'User Abandoned', checked: false, tooltipContent: 'The customer drops off from a conversation without reaching a legitimate end response configured on the bot.' },
            {
              label: 'Escalation not Connected',
              checked: false,
              tooltipContent: 'The customer requests to be connected to a live agent but the handoff from virtual to live agent does not take place.',
            },
            { label: 'False Positives', checked: false, tooltipContent: 'The customer received an unrelated response to their query.' },
            { label: 'Negative Feedback', checked: false, tooltipContent: 'The virtual agent receives explicit negative feedback from the customer during a conversation.' },
          ],
          selectAll: false,
          selectedOptions: [],
          initialSelectedOptions: [],
          opened: false,
          show: this.activeSubPage && this.activeSubPage === TabNameEnum.AUTOMATION,
          showFilterReset: false,
          isReset: false,
        },
      ],

      showWarningMsgForKeywordSearch: false
    };
  },

  computed: {
    ...mapGetters(['dataModel']),

    getBesSelectedOptions() {
      return this.transcriptDropdowns.find((dropdown) => dropdown.title === DropdownOptionsEnum.BES).selectedOptions;
    },
    getBasSelectedOptions() {
      return this.transcriptDropdowns.find((dropdown) => dropdown.title === DropdownOptionsEnum.BAS).selectedOptions;
    },
    isAdvancedSearchApplyDisabled() {
      const isPayloadEmpty = this.checkAdvancedFilterIsEmpty()
      const isChanged = this.checkAdvancedFilterChanges();

      // if re-open after applySearch
      if (this.showAdvancedSearchFilter && !isPayloadEmpty && !isChanged) {
        return true;
      }
      // if reset all
      if (isPayloadEmpty && isChanged && !this.isShowGroups && this.searchType == '1') {
        return false;
      }

      for (const group in this.advancedFilterPayload) {
        if (group === 'groupOperators') {
          if ((this.advancedFilterPayload.groupB && !this.advancedFilterPayload.groupOperators.groupBOperator) || 
              (this.advancedFilterPayload.groupC && !this.advancedFilterPayload.groupOperators.groupCOperator)) {
            return true;
          }
        } else {
          const conditions = this.advancedFilterPayload[group] && this.advancedFilterPayload[group].conditions;
          if (conditions) {
            for (const condition of conditions) {
              if ((condition.messageType && condition.messageType.length === 0) || !condition.searchType || !condition.value) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },

    isAdvancedSearchConditionsMaxed() {
      const groupAConditionsLength = this.advancedFilterPayload.groupA.conditions.length;
      const groupBConditionsLength = this.advancedFilterPayload.groupB && this.advancedFilterPayload.groupB.conditions.length;
      const groupCConditionsLength = this.advancedFilterPayload.groupC && this.advancedFilterPayload.groupC.conditions.length;

      const totalConditions = groupAConditionsLength + (groupBConditionsLength || 0) + (groupCConditionsLength || 0);
      return totalConditions >= this.MAX_TOTAL_CONDITIONS;
    },
  },

  watch: {
    searchText: {
        handler: function(newVal) {
          if (newVal == '') {
            this.isInitialUpdateAdvancedFilter = false;
          }
        }
      },
    advancedFilterPayload : {
      handler: function(newVal) {
        const value = newVal.groupA.conditions[0].value;
        this.searchText = value

        if (this.isInitialUpdateAdvancedFilter) return;

        if (value != '' && value != null && newVal.groupA.conditions[0].messageType.length == 0) {
          this.isInitialUpdateAdvancedFilter = true;

          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupA: {
              ...this.advancedFilterPayload.groupA,
              conditions: this.advancedFilterPayload.groupA.conditions.map((condition, index) => {
                if (index === 0) {
                  return { messageType: ['Customer', 'Bot', 'Agent'], searchType: "1", value: value }
                }
                return condition;
              })
            }
          }
        }
      },
      deep: true
    },
    isShowGroups: {
      handler: function() {
        this.handleAdvancedFilterHeightSizing();
      },
      deep: true
    },
    searchType: {
      handler: function(newVal) {
        this.handleAdvancedFilterHeightSizing();
        if (newVal == '2') {
          this.isSearchInputDisabled = false;
          let filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-metric-search-filter-tag-wrapper');
          if(filterTagWrapper) {
            let tag = filterTagWrapper.querySelector('.advanced-metric-search-filter-tag-advanced')
            if(tag && tag.textContent != 'Conversation ID search applied') {
              this.showWarningMsgForKeywordSearch = true;
            }
          }
          else {
            if(this.searchText == null || this.searchText == '') {
              this.showWarningMsgForKeywordSearch = false;
            }
            else {
              this.showWarningMsgForKeywordSearch = true;
            }
          }
        }
      },
      deep: true
    },
  },

  methods: {
    ...mapActions(['fetchTranscriptSearchTimeRange']),

    async renderPageLogic(subPage) {
      this.localFilterMap.searchType = this.searchType;
      this.localFilterMap.searchFor = this.searchFor;
      this.localFilterMap.searchIn = this.searchIn;
      this.localFilterMap.searchText = this.searchText
      this.localFilterMap.isShowGroups = this.isShowGroups;

      await this.loadTranscriptData();
      this.handleShowSubPageDropdown(subPage);
    },

    async loadTranscriptData(filterName) {
      const transcriptResultsRef = this.$refs.transcriptSearchResults;

      if (transcriptResultsRef) {
        this.transcriptLoading = true;
        let timeRangeResult = await this.fetchTranscriptSearchTimeRange(this.topicDisplayName);
        // do the search when timeRangeResult's range time is not -1 && must have contact reasons
        if(timeRangeResult && timeRangeResult.data 
        && timeRangeResult.data.minHandlingTime > -1 && timeRangeResult.data.maxHandlingTime > -1
        && timeRangeResult.data.minTransferCount > -1 && timeRangeResult.data.maxTransferCount > -1 
        && timeRangeResult.data.minAgentHandlingTime > -1 && timeRangeResult.data.maxAgentHandlingTime > -1
        && timeRangeResult.data.minAgentResponseTime > -1 && timeRangeResult.data.maxAgentResponseTime > -1 
        && timeRangeResult.data.minAgentWaitTime > -1 && timeRangeResult.data.maxAgentWaitTime > -1 
        && this.$refs.transcriptSearchResults) {
          this.$refs.transcriptSearchResults.prepareTimeRange(timeRangeResult);
        }
        const mergedTopics = this.parent && this.parent.parentCurrentItem && this.parent.parentCurrentItem.mergedTopics || [];
        await transcriptResultsRef.loadMetricTopicConversations(1, {}, filterName, mergedTopics);
        setTimeout(() => {
          this.closeAllDropdowns();
        }, 10);
      }
      this.transcriptLoading = false;
    },

    handleShowSubPageDropdown(subPage) {
      // to handle edge cases where bes and bas is selected by condition from global filter no data
      // e.g. bes == 100 || bes == -1, so default activeSubPage -> bas
      let dropdown;
      if (subPage === TabNameEnum.EXPERIENCE) dropdown = DropdownOptionsEnum.BES;
      if (subPage === TabNameEnum.AUTOMATION) dropdown = DropdownOptionsEnum.BAS;

      this.transcriptDropdowns.forEach((d) => {
        d.show = false;
      });

      const transcriptDropdown = this.transcriptDropdowns.find((d) => d.title === dropdown);
      transcriptDropdown.show = true;
    },

    handleTranscriptExpand(value) {
      this.isTranscriptExpanded = value;

      if (value) {
        this.$refs.searchFilters.style.display = 'none';
      } else {
        this.$refs.searchFilters.style.display = 'flex';
      }
    },

    toggleSavedTranscriptFilter() {
      if (this.activeSubPage === TabNameEnum.EXPERIENCE) {
        this.savedTranscriptResultBes = !this.savedTranscriptResultBes;
      }
      if (this.activeSubPage === TabNameEnum.AUTOMATION) {
        this.savedTranscriptResultBas = !this.savedTranscriptResultBas;
      }
      this.applySearch(null, 'Saved Transcripts');
    },

    getListOfCheckedOptions() {
      let selectedOptions;
      if (this.activeSubPage === TabNameEnum.EXPERIENCE) selectedOptions = this.getBesSelectedOptions; // OC-1593: Additional transcript requirements
      if (this.activeSubPage === TabNameEnum.AUTOMATION) selectedOptions = this.getBasSelectedOptions;

      const signalPayloadMapper = Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER;
      const selectedTabMapper = signalPayloadMapper[this.activeSubPage];
      const mappedSelectedOptions = new Set(selectedOptions.map((option) => selectedTabMapper[option]));
      return [...mappedSelectedOptions];
    },

    toggleTranscriptDropdown(dropdown) {
      dropdown.opened = !dropdown.opened;
    },

    updateSelectedOptions(dropdown) {
      dropdown.selectedOptions = dropdown.options.filter((option) => option.checked).map((option) => option.label);
    },

    handleTranscriptDropdownState(dropdown, visible, command) {
      const currFilterSize = dropdown.selectedOptions.length;
      const initialOptions = dropdown.initialSelectedOptions.length;

      dropdown.opened = visible;

      if (command == 'close') {
        // If we 'reset all' but click cancel, we need to repopulate with initial selected options
        dropdown.options.forEach((option) => {
          option.checked = dropdown.initialSelectedOptions.includes(option.label);
        });
        this.updateSelectedOptions(dropdown);
        if (initialOptions) dropdown.showFilterReset = true;
        if (dropdown.isReset) dropdown.isReset = false;
        return;
      }

      if (visible || (currFilterSize == 0 && initialOptions == 0) || currFilterSize === initialOptions) {
        return;
      }

      if (dropdown.isReset && !currFilterSize) {
        dropdown.isReset = false;
        return this.applySearch();
      }
      if(dropdown.title == 'BES Signals' || dropdown.title == 'BAS Signals') {
        return this.applySearch(null, dropdown.title);
      }
      this.applySearch();
    },

    handleTranscriptDropdownCommand(command, dropdown) {
      if (command === 'reset') {
        dropdown.options.forEach((option) => {
          option.checked = false;
        });
        dropdown.selectAll = false;
        this.updateAllDropdowns(dropdown);

        dropdown.showFilterReset = false;
        dropdown.isReset = true;
      } else if (command === 'close') {
        this.closeAllDropdowns();
        this.handleTranscriptDropdownState(dropdown, false, command);
      } else if (command === 'applySearch') {
        this.closeAllDropdowns();

        let dropdownTitle = null;
        if (this.activeSubPage === TabNameEnum.EXPERIENCE) {
          dropdownTitle = DropdownOptionsEnum.BES;
        } else if (this.activeSubPage === TabNameEnum.AUTOMATION) {
          dropdownTitle = DropdownOptionsEnum.BAS;
        }

        this.applySearch(null, dropdownTitle);
      }
    },

    handleRemoveTranscriptFilter(dropdown) {
      const currDropdownHasFilters = dropdown.selectedOptions.length;

      if (dropdown && currDropdownHasFilters) {
        dropdown.options.forEach((option) => {
          option.checked = false;
        });
        dropdown.selectAll = dropdown.options.every((option) => option.checked === true);
        dropdown.initialSelectedOptions = [];
      }

      this.updateAllDropdowns(dropdown);

      if (currDropdownHasFilters) {
        this.applySearch();
        setTimeout(() => {
          this.closeAllDropdowns();
        }, 10);
      }

      // this.showFilterReset = false;
      dropdown.showFilterReset = false;
    },

    handleResetAllTranscriptFilters() {
      this.transcriptDropdowns.forEach((dropdown) => {
        dropdown.options.forEach((option) => {
          option.checked = false;
        });
        dropdown.selectAll = false;
        dropdown.selectedOptions = [];
        dropdown.initialSelectedOptions = [];
        dropdown.showFilterReset = false;
        this.updateSelectedOptions(dropdown);
      });
      this.savedTranscriptResultBes = false;
      this.savedTranscriptResultBas = false;

      this.handleResetAllAdvancedSearch();
    },

    updateAllDropdowns(dropdown) {
      this.updateIfAllSelected();
      this.updateSelectedOptions(dropdown);
    },

    closeAllDropdowns() {
      this.transcriptDropdowns.forEach((dropdown) => {
        dropdown.opened = false;
      });
      this.$refs.dropdown.forEach((dropdown) => {
        dropdown.hide();
      });
    },

    toggleAllTranscriptOptions(dropdown) {
      dropdown.options.forEach((option) => {
        option.checked = dropdown.selectAll;
      });

      const otherDropdown = this.transcriptDropdowns.find((item) => item.title !== dropdown.title);
      this.updateAllDropdowns(dropdown, otherDropdown);
    },

    handleOptionChange(dropdown, label) {
      const dropdownOption = dropdown.options.find((option) => option.label === label);
      dropdownOption && (dropdownOption.checked = !dropdownOption.checked);

      this.updateIfAllSelected();
      this.updateSelectedOptions(dropdown);
    },

    updateIfAllSelected() {
      const besDropdown = this.transcriptDropdowns.find((dropdown) => dropdown.title === DropdownOptionsEnum.BES);
      const basDropdown = this.transcriptDropdowns.find((dropdown) => dropdown.title === DropdownOptionsEnum.BAS);

      besDropdown.selectAll = besDropdown.options.every((option) => option.checked === true);
      basDropdown.selectAll = basDropdown.options.every((option) => option.checked === true);
    },

    hideTranscriptPopover() {
      if (this.parent) {
        this.parent.handleTranscriptPopover();
      }
    },

    onSearchFocus() {
      document.querySelector('.search-input-wrapper').style.border = '1px solid #106FBC';
      this.hideTranscriptPopover();
    },

    onSearchBlur() {
      document.querySelector('.search-input-wrapper').style.border = '1px solid #c9cccf';
    },

    onSearchHover(value) {
      const searchInputRef = this.$refs.searchInput;
      if (searchInputRef) {
        if (value) {
          if (!searchInputRef.$el) return;
          searchInputRef.$el.style.backgroundColor = '#F5F7FA';
          searchInputRef.$el.style.borderRadius = '20px';
        } 
      }
    },

    onSearchLeave(value) {
      const searchInputRef = this.$refs.searchInput;
      if (searchInputRef) {
        if (value) {
          if (!searchInputRef.$el) return;
          searchInputRef.$el.style.backgroundColor = 'transparent';
          searchInputRef.$el.style.borderRadius = '20px';
        } 
      }
    },

    onSearchForFocus() {
      const ref = this.$refs.advancedSearchFor
      if (ref) {
        if (!ref.$el) return;
        ref.$el.style.border = '1px solid #106FBC';
      }
    },

    onSearchForBlur() {
      const ref = this.$refs.advancedSearchFor
      if (ref && ref.$el &&document.activeElement != ref.$el.children[0]) {
        ref.$el.style.border = '1px solid #CAD2DA';
      }
    },

    clearSearchInput() {
      this.isInitialUpdateAdvancedFilter = false;
      this.isSearchInputDisabled = false;
      this.searchType = '1'
      this.handleResetAllAdvancedSearch();
      
      if (this.isAdvancedFilterApplied()) {
        this.applySearch();
      } else {
        this.handleCloseAdvancedSearch();
      }
      // this.applySearch(); // handled by handleEventsOutsideOfPopover
    },

    checkArrayEqual(array1, array2) {
      let changed = false;
      if(!array1) {
        array1 = []
      }
      if(!array2) {
        array2 = []
      }
      array1.forEach(item=>{
        if(!array2.includes(item)) {
          changed = true
        }
      })
      array2.forEach(item=>{
        if(!array1.includes(item)) {
          changed = true
        }
      })
      return changed;
    },

    checkAdvancedFilterIsEmpty() {
      return this.advancedFilterPayload.groupA.conditions.length == 1 && 
        !this.advancedFilterPayload.groupA.conditions[0].searchType &&
        !this.advancedFilterPayload.groupA.conditions[0].messageType.length &&
        !this.advancedFilterPayload.groupA.conditions[0].value && 
        !this.advancedFilterPayload.groupB && 
        !this.advancedFilterPayload.groupC
    },

    checkAdvancedFilterChanges() {
      let changed = false;
      if (
        this.searchText != this.localFilterMap.searchText ||
        this.searchType != this.localFilterMap.searchType ||
        this.isShowGroups != this.localFilterMap.isShowGroups ||
        JSON.stringify(this.advancedFilterPayload) != JSON.stringify(this.localFilterMap.advancedFilterPayload)
      ) {
        changed = true
      }
      return changed
    },

    handleEventsOutsideOfPopover() {
      this.hideInnerDropdowns();

      if (this.isAdvancedFilterReset && !this.isAdvancedSearchApplyDisabled) {
        this.isAdvancedFilterReset = false;
        this.applySearch();
        return;
      }

      this.showAdvancedSearchFilter = false;

      if (this.isAdvancedSearchApplyDisabled) {
        // case: not all conditions are filled, so we remove the unfilled conditions
        this.handleCancelAdvancedSearch();
        return;
      }

      const filterChanged = this.checkAdvancedFilterChanges()

      if (filterChanged) {
        this.handleApplyAdvancedSearch();
      } else {
        this.handleCancelAdvancedSearch()
      }

    },

    handleHideAdvancedFilterIconTooltip() {
      if (this.$refs.advancedSearchTooltip) {
        this.$refs.advancedSearchTooltip.hide();
      }
    },
    handleCloseAdvancedSearch() {
      this.showAdvancedSearchFilter = false;
    },

    handleCancelAdvancedSearch() {
      this.isAdvancedFilterReset = false;

      this.searchType = this.localFilterMap.searchType;
      this.searchText = this.localFilterMap.searchText;
      this.isShowGroups = this.localFilterMap.isShowGroups;
      this.advancedFilterPayload = JSON.parse(JSON.stringify(this.localFilterMap.advancedFilterPayload)); // create a deep + defensive copy

      const filterPreviouslyApplied = !this.isAdvancedSearchApplyDisabled
      if (filterPreviouslyApplied) {
        this.handleCreateTags();
        this.isSearchInputDisabled = true;
      }

      if(!this.searchText || this.searchText == '') {
        this.isInitialUpdateAdvancedFilter = false;
      }

      this.handleCloseAdvancedSearch();
    },

    handleSetElInputWidth(widthSizePx) {
      const elInput = document.querySelector('.search-header .search-input-field .el-input__inner');
      if(elInput) {
        elInput.style.paddingLeft = `${widthSizePx}px`;
      }
    },

    handleApplyAdvancedSearch() {
      const isNotEmptySearch = this.advancedFilterPayload.groupA.conditions.every(condition => condition.value && condition.value != '');
      if (isNotEmptySearch) {
        this.isSearchInputDisabled = true;
        this.handleCreateTags();
      }

      if (this.searchType == '2') {
        // if searchType is "Conversation ID", we reset the payload.
        // Reason: If groups are created, we want to keep the groups even if searchType changes 
        // until the user for sure searches with conversation ID
        this.isSearchInputDisabled = true;
        this.initializeAdvancedFilterPayload();
      }
      if(!this.showAdvancedSearchFilter) {
        this.applySearch();
      }
      else {
        this.handleCloseAdvancedSearch();
      }
      
    },
    handleCreateTags() {
      // Check if filter wrapper exists
      if (!this.$refs.searchInput) return;
      let filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-metric-search-filter-tag-wrapper');

      if (!filterTagWrapper) {
        filterTagWrapper  = document.createElement('div');
        filterTagWrapper.classList.add('advanced-metric-search-filter-tag-wrapper');
        // this.handleSetElInputWidth(8)
      }
      // const searchInTag = this.handleCreateSearchInTags(filterTagWrapper);
      // const searchForTag = this.handleCreateSearchForTags(filterTagWrapper);

      const advancedSearchTag = this.handleCreateAdvancedSearchTag(filterTagWrapper);

      // make sure that the searchInTag is always the first child
      // if (searchInTag) filterTagWrapper.insertBefore(searchInTag, filterTagWrapper.firstChild);
      // if (searchForTag) filterTagWrapper.appendChild(searchForTag);
      if (advancedSearchTag) filterTagWrapper.appendChild(advancedSearchTag);
      const searchInputRefEl = this.$refs.searchInput.$el;
      searchInputRefEl.insertBefore(filterTagWrapper, searchInputRefEl.firstChild);
    },

    handleCreateAdvancedSearchTag(filterTagWrapper) {
      let advancedSearchTag = filterTagWrapper.querySelector('.advanced-metric-search-filter-tag-advanced');
      if (advancedSearchTag) {
        filterTagWrapper.removeChild(advancedSearchTag); // remove the existing tag
      }
      advancedSearchTag = document.createElement('div');
      advancedSearchTag.classList.add('advanced-metric-search-filter-tag-advanced');

      if (this.searchType == '1') advancedSearchTag.textContent = 'Keyword/Phrase search applied'
      else if (this.searchType == '2')  advancedSearchTag.textContent = 'Conversation ID search applied';

      this.showWarningMsgForKeywordSearch = false;
      this.createAdvancedSearchHoverText()

      return advancedSearchTag
    },

    createAdvancedSearchHoverText() {
      let hoverText = '';

      if (this.searchType == '1') {
        this.allowed_groups.forEach((key, index) => {
          const group = this.advancedFilterPayload[key];
  
          if (group) {
            if (index > 0) {
              hoverText += '<br/>';
              hoverText += `${this.operatorsEnumBetweenGroup.find(en => en.key == this.advancedFilterPayload.groupOperators[index === 1 ? 'groupBOperator' : 'groupCOperator']).label}<br/><br/>`;
            }
  
            group.conditions.forEach((condition, conditionIndex) => {
              const notAndNotOrCondition = this.operatorsEnum.find(en => en.key == group.operator).key == '3' || this.operatorsEnum.find(en => en.key == group.operator).key == '4'
              const operatorLabel = notAndNotOrCondition|| conditionIndex > 0 
                    ? `${this.operatorsEnum.find(en => en.key == group.operator).label} ` 
                    : '';
              const searchForLabel = condition.searchType ? this.searchForList.find(item => item.key === condition.searchType).label : '';
              const messageTypeLabels = condition.messageType.length == 3 ? 'all messages' : condition.messageType.map(item => this.searchInList.find(searchInItem => searchInItem.apiField == item).label).join(', ');
  
              hoverText += `${operatorLabel}${notAndNotOrCondition || conditionIndex > 0 ? searchForLabel.toLowerCase() : searchForLabel} in ${messageTypeLabels} for <b>${condition.value}</b><br/>`;
            });
          }
        });
      } else if (this.searchType == '2') {
        hoverText = this.searchText;
      }

      this.isShowAdvancedFilterResultsTooltip = true;
      this.$refs.advancedFilterHoverSlot.innerHTML = hoverText;
    },
    // handleCreateSearchInTags(filterTagWrapper) {
    //   const searchInFilter = this.searchInList.filter(item => this.searchIn.includes(item.key)).map(item => item.label);
    //   const ALL_OPTIONS_SELECTED = 3
    //   const NO_OPTIONS_SELECTED = 0
    //   if (searchInFilter && (searchInFilter.length === ALL_OPTIONS_SELECTED || searchInFilter.length === NO_OPTIONS_SELECTED)) {
    //     // remove first tag (created from searchIn just to leave with searchFor tag)
    //     const wrapperLength = filterTagWrapper.children.length || 0;
    //     if (wrapperLength >= 1) {
    //       filterTagWrapper.removeChild(filterTagWrapper.firstChild);
    //     }
    //     return
    //   }

    //   // remove the word "messages" in each element in the array except for the last element
    //   searchInFilter.forEach((item, index) => {
    //     if (index !== searchInFilter.length - 1) {
    //       searchInFilter[index] = item.replace(' messages', '');
    //     }
    //   });
    //   let searchInTag = filterTagWrapper.querySelector('.advanced-metric-search-filter-tag-in');
    //   const isSearchInTagSameKey = searchInTag && searchInTag.getAttribute('data-key') === this.searchIn.join(',');
    //   if (searchInTag && isSearchInTagSameKey) {
    //     return; // do nothing
    //   } else if (searchInTag && !isSearchInTagSameKey) {
    //     filterTagWrapper.removeChild(searchInTag); // remove the existing tag
    //   }
    //   searchInTag = document.createElement('div');
    //   searchInTag.classList.add('advanced-metric-search-filter-tag-in');
    //   searchInTag.textContent = `in: ${searchInFilter.map(item => item.toLowerCase()).join(', ')}`;
    //   searchInTag.setAttribute('data-key', this.searchIn.join(','));
      
    //   return searchInTag
    // },
    // handleCreateSearchForTags(filterTagWrapper) {
    //   const searchForFilter = this.searchForList.find(item => item.key === this.searchFor).label;      
    //   let searchForTag = filterTagWrapper.querySelector('.advanced-metric-search-filter-tag-for');
    //   const isSearchForTagSameKey = searchForTag && searchForTag.getAttribute('data-key') === this.searchFor;

    //   if (!this.searchText || this.searchType == '2') {
    //     if (searchForTag) filterTagWrapper.removeChild(searchForTag); // remove the existing tag
    //     return;
    //   }
    //   if (searchForTag && isSearchForTagSameKey) {
    //     return; // do nothing
    //   } else if ((searchForTag && !isSearchForTagSameKey)) {
    //     filterTagWrapper.removeChild(searchForTag); // remove the existing tag
    //   }
    //   searchForTag = document.createElement('div');
    //   searchForTag.classList.add('advanced-metric-search-filter-tag-for');
    //   searchForTag.textContent = searchForFilter.toLowerCase();
    //   searchForTag.setAttribute('data-key', this.searchFor);
    //   return searchForTag
    // },
    
    handleResetAllAdvancedSearch() {
      this.searchType = '1'   
      this.searchText = null;
      this.isAdvancedFilterReset = true;
      this.handleSetElInputWidth(37)

      this.isShowGroups = false;
      this.isSearchInputDisabled = false;

      this.advancedFilterPayload = {
        groupOperators: { groupBOperator: null, groupCOperator: null},
        groupA: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }]
        }
      };
      this.isInitialUpdateAdvancedFilter = false;
      this.isShowAdvancedFilterResultsTooltip = false;

      this.removeAllSearchTags();
    },
    removeAllSearchTags() {
      if (!this.$refs.searchInput) return;
      this.handleSetElInputWidth(37)
      const filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-metric-search-filter-tag-wrapper');
      if (filterTagWrapper) {
        filterTagWrapper.remove();
      }
    },

    applySearch(el, filterName = 'Direct Search Activation') {
      let dropdownTitle;
      if (this.activeSubPage === TabNameEnum.EXPERIENCE) {
        dropdownTitle = DropdownOptionsEnum.BES;
      }
      if (this.activeSubPage === TabNameEnum.AUTOMATION) {
        dropdownTitle = DropdownOptionsEnum.BAS;
      }

      const dropdown = this.transcriptDropdowns.find((dropdown) => dropdown.title === dropdownTitle);
      dropdown.showFilterReset = true;
      dropdown.initialSelectedOptions = [];
      dropdown.selectedOptions.forEach((option) => {
        dropdown.initialSelectedOptions.push(option);
      });

      if (!dropdown.selectedOptions.length) dropdown.showFilterReset = false;

      this.localFilterMap.searchType = this.searchType;
      this.localFilterMap.searchText = this.searchText
      this.localFilterMap.isShowGroups = this.isShowGroups;
      this.localFilterMap.advancedFilterPayload = JSON.parse(JSON.stringify(this.advancedFilterPayload));

      const isNotEmptySearch = this.advancedFilterPayload.groupA.conditions.every(condition => condition.value && condition.value != '');
      if (isNotEmptySearch) {
        this.isSearchInputDisabled = true;
        this.handleCreateTags();
      }

      this.loadTranscriptData(filterName);
      this.handleCloseAdvancedSearch();
    },

    // ---- //
    handleAddMainCondition() {
      this.isShowGroups = true;
      
      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        groupOperators: {
          groupBOperator: null
        },
        groupA: {
          ...this.advancedFilterPayload.groupA,
          conditions: [...this.advancedFilterPayload.groupA.conditions]
        },
        groupB: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }],
        },
      }
    },
    
    handleAddMainGroup() {
      const firstTimeAdding = !this.isShowGroups
      if (firstTimeAdding) {
        this.isShowGroups = true;
        this.advancedFilterPayload = {
          ...this.advancedFilterPayload,
          groupA: {
            ...this.advancedFilterPayload.groupA,
            conditions: [...this.advancedFilterPayload.groupA.conditions]
          }
        };
        return;
      }

      const newGroup = this.advancedFilterPayload.groupB ? 'groupC' : 'groupB';

      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        groupOperators: {
          groupBOperator: this.advancedFilterPayload.groupB ? this.advancedFilterPayload.groupOperators.groupBOperator : null, 
          groupCOperator: null
        },
        [newGroup]: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }]
        }
      };
    },

    handleDeleteGroup(group) {
      if (group === 'groupA') {
        if(this.advancedFilterPayload.groupB && this.advancedFilterPayload.groupC) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: { 
              groupBOperator: this.advancedFilterPayload.groupOperators.groupCOperator, 
              groupCOperator: null
            },
            groupA: this.advancedFilterPayload.groupB,
            groupB: this.advancedFilterPayload.groupC,
            groupC: null
          };
          return;
        } else if (this.advancedFilterPayload.groupB) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: { 
              groupBOperator: null, 
              groupCOperator: null
            },
            groupA: this.advancedFilterPayload.groupB,
            groupB: null
          };
          return;
        } else if (this.advancedFilterPayload.groupC) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: { 
              groupBOperator: null, 
              groupCOperator: null
            },
            groupA: this.advancedFilterPayload.groupC,
            groupC: null
          };
          return;
        } else {
          this.handleResetAllAdvancedSearch();
          return;
        }
      } else if (group === 'groupB') {
        if (this.advancedFilterPayload.groupC) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: {
              // groupCOperator (B-C) takes priority over groupBOperator (A-B)
              groupBOperator: this.advancedFilterPayload.groupOperators.groupCOperator,
              groupCOperator: null
            },
            groupB: this.advancedFilterPayload.groupC,
            groupC: null
          };
          return;
        } else {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: {
              groupBOperator: null,
              groupCOperator: null
            },
            groupB: null
          };
          return;
        }
      } else if (group === 'groupC') {
        this.advancedFilterPayload = {
          ...this.advancedFilterPayload,
          groupOperators: {
            groupBOperator: this.advancedFilterPayload.groupOperators.groupBOperator,
            groupCOperator: null
          },
          groupC: null
        };
        return;
      }
    },


    handleAddCondition(group) {
      const filterGroup = this.advancedFilterPayload[group];

      const newCondition ={ 
        searchType: null,
        messageType: [], 
        value: null
      }

      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        [group]: {
          ...filterGroup,
          conditions: [...filterGroup.conditions, newCondition]
        }
      }
    },

    handleDeleteCondition(group, condition) {
      const filterGroup = this.advancedFilterPayload[group];

      if (!filterGroup) {
        return; // Group doesn't exist, nothing to delete
      }

      const updatedConditions = filterGroup.conditions.filter(cond => cond !== condition);

      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        [group]: {
          ...filterGroup,
          conditions: updatedConditions
        }
      };
    },

    handleMessageTypeText(condition) {
      const messageType = condition.messageType;

      if (messageType.length === 0) return 'In: Message type';

      let firstSelectedMessageType = this.searchInList.find(item => item.apiField === messageType[0]).label;

      const max_render_length = 12;
      if (firstSelectedMessageType.length >= max_render_length) {
        firstSelectedMessageType = firstSelectedMessageType.substring(0, max_render_length) + '...';
      }

      const moreThanOneSelected = messageType.length > 1;
      const remainingSelected = moreThanOneSelected ? messageType.length - 1 : 0;

      return `${firstSelectedMessageType}${moreThanOneSelected ? ` + ${remainingSelected}` : ''}`;

    },

    handleDefaultMessageTypeDropdownVisibleChange(val) {
      if (val) {
      const iconPlacement = document.querySelector('.placement');
      if (iconPlacement) {
        iconPlacement.classList.add('icon-placement-rotate');
        iconPlacement.classList.remove('icon-placement-rotate-back');
      }

      } else {
        const iconPlacement = document.querySelector('.placement');
        if (iconPlacement) {
          iconPlacement.classList.remove('icon-placement-rotate');
          iconPlacement.classList.add('icon-placement-rotate-back');
        }
      }
    },

    handleGroupMessageTypeDropdownVisibleChange(val, index) {
      const iconPlacement = document.querySelector(`.group-placement-${index}`)
      const classList = iconPlacement && iconPlacement.classList ? iconPlacement.classList : [];

      if (!classList || !classList.length || !iconPlacement) return;

      if (!val && iconPlacement && Array.from(classList).includes('icon-placement-rotate')) {
        classList.remove('icon-placement-rotate');
        classList.add('icon-placement-rotate-back');
      } else {
        classList.add('icon-placement-rotate');
        classList.remove('icon-placement-rotate-back');
      }
    },

    handleAdvancedFilterHeightSizing() {
      this.$nextTick(() => {
        let height = 'min-content';

        if ((this.searchType == '1' && this.isShowGroups)) {
          height = '280px';
        }

        this.$refs.advancedFilterBody.style.height = height;
      });
      // this.$refs.advancedFilterBody.scrollTop = this.$refs.advancedFilterBody.scrollHeight;
    },

    handleSearchInputClick() {
      if (!this.isAdvancedSearchApplyDisabled && this.isSearchInputDisabled) {
        this.showAdvancedSearchFilter = true;
      }
    },

    getAdvancedFilterPayload() {
      let groupOperators = {};

      if (this.searchType == '2') {
        return groupOperators;
      }
      if (this.advancedFilterPayload.groupOperators.groupBOperator) {
        groupOperators.groupBOperator = this.advancedFilterPayload.groupOperators.groupBOperator;
      }
      if (this.advancedFilterPayload.groupOperators.groupCOperator) {
        groupOperators.groupCOperator = this.advancedFilterPayload.groupOperators.groupCOperator;
      }

      let advancedFilter = {};
      advancedFilter.groupOperators = groupOperators;

      if (this.advancedFilterPayload.groupA) {
        advancedFilter.groupA = this.advancedFilterPayload.groupA;
      }
      if (this.advancedFilterPayload.groupB) {
        advancedFilter.groupB = this.advancedFilterPayload.groupB;
      }
      if (this.advancedFilterPayload.groupC) {
        advancedFilter.groupC = this.advancedFilterPayload.groupC;
      }

      return advancedFilter;
    },

    handleEnterSearch() {
      if (this.searchText == '' || this.searchText == null) return; 

      this.initializeAdvancedFilterPayload()
      this.handleApplyAdvancedSearch();
    },

    initializeAdvancedFilterPayload() {
      this.advancedFilterPayload = {
        groupOperators: {},
        groupA: {
          operator: "1",
          conditions: [{ messageType: ['Customer', 'Bot', 'Agent'], searchType: "1", value: this.searchText }]
        },
      }
    },

    hideInnerDropdowns() {
      const searchByDropdown = this.$refs.searchByDropdown
      if (searchByDropdown && searchByDropdown.blur) {
        searchByDropdown.blur()
      }

      // hide all inner dropdowns in advanced search when scroll
      const innerGroupOperatorDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('innerGroupOperatorDropdown-')) 
      if (innerGroupOperatorDropdowns && innerGroupOperatorDropdowns.length) {
        innerGroupOperatorDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.blur) {
            refInstance.blur()
          }
        })
      }

      const searchTypeDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('searchTypeDropdown-'))
      if (searchTypeDropdowns && searchTypeDropdowns.length) {
        searchTypeDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.blur) {
            refInstance.blur()
          }
        })
      }

      const messageTypeDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('messageTypeDropdown-'))
      if (messageTypeDropdowns && messageTypeDropdowns.length) {
        messageTypeDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.hide) {
            refInstance.hide()
          }
        })
      }

      const outerGroupOperatorDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('outerGroupOperatorDropdown-'))
      if (outerGroupOperatorDropdowns && outerGroupOperatorDropdowns.length) {
        outerGroupOperatorDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.blur) {
            refInstance.blur()
          }
        })
      }
    },

    mouseover(e, tooltips, type, scaleX) {
      e.stopPropagation();
      // let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' 
      // && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' 
      // && e.target.className != 'el-select el-select--mini'
      if(tooltips && tooltips.trim() != '') {
        this.mouseoverHandler = e;
        let tooltipsEl = document.querySelector(".site-tooltips");
        if(tooltipsEl) {
          tooltipsEl.innerHTML = tooltips
          tooltipsEl.style.display = 'block';
          tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
          if(!scaleX) {
            scaleX = 10
          }
          if(type == "right") {
            tooltipsEl.style.right = "10px";
            tooltipsEl.style.left = "unset";
          }
          if(type == "left") {
            tooltipsEl.style.left = "10px";
            tooltipsEl.style.right = "unset";
          }
          if(!type || type == "normal") {
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width/2 + scaleX}px`;
          }
          tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
        }
      }
      else {
        e.preventDefault();
      }
    },
    mouseout(e) {
      if(e) {
        e.stopPropagation();
      }
      this.mouseoverHandler = null;
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
      }
    },
    isAdvancedFilterApplied() {
      return (
        this.localFilterMap.searchText || 
        (
          this.localFilterMap.advancedFilterPayload.groupA.conditions[0].value != null &&
          this.localFilterMap.advancedFilterPayload.groupA.conditions[0].value != ''
        ) ||
        this.localFilterMap.advancedFilterPayload.groupB
      )
    }
  },

  async mounted() {
    const searchInputRef = this.$refs.searchInput
    if (searchInputRef) {
      searchInputRef.$el.addEventListener('click', this.handleSearchInputClick)
    }

    // hide all inner dropdowns in advanced search when scroll
    document.querySelector('.wy-analytics-transcript-search-dropdown-menu.search-input .body').addEventListener('scroll', () => {
      this.hideInnerDropdowns();
    });

    // hide tooltip on tab switch
    document.addEventListener('visibilitychange', () => {
      const isAdvancedSearchIconFocused = document.activeElement.classList.contains('advanced-search-icon');
      if (isAdvancedSearchIconFocused) {
        document.activeElement.blur();
      }
    });
  },

  created() {
    this.localFilterMap.advancedFilterPayload = JSON.parse(JSON.stringify(this.advancedFilterPayload));
    this.localFilterMap.searchText = this.searchText
    this.localFilterMap.searchType = this.searchType
    this.localFilterMap.isShowGroups = this.isShowGroups
  }
});
</script>

<style lang="scss">
// required for the advanced search filter (disabled click)
input[disabled] {pointer-events:none}

.advanced-metric-wrapper {
  padding: 0px !important;
  margin: 0px;
  border-radius: 10px;
  left: 395px !important;
  // scale: 0.93; #882200 #36
  margin-left: -30px;
}
.advanced-metric-search-filter-tag-wrapper {
  margin-left: 36px;
  display: flex;
  align-items: center;
  gap: 6px;

  .advanced-metric-search-filter-tag-advanced {
      padding: 0px 14px;
      background-color: #E8F1FF;
      color: rgb(16, 111, 188);
      font-size: 14px;
      line-height: 40px;
      font-weight: 500;
      border-radius: 5px;
      height: 22px;
      display: flex;
      align-items: center;
      min-width: max-content;
      width: 210px;
      cursor: pointer;
    }
  
  // .advanced-metric-search-filter-tag-for {
  //   padding: 0px 14px;
  //   background-color: #E8F1FF;
  //   color: rgb(16, 111, 188);
  //   font-size: 14px;
  //   line-height: 40px;
  //   font-weight: 500;
  //   border-radius: 5px;
  //   height: 22px;
  //   display: flex;
  //   align-items: center;
  //   min-width: max-content;
  // }

  // .advanced-metric-search-filter-tag-in {
  //   padding: 0px 14px;
  //   background-color: #E8F1FF;
  //   color: rgb(16, 111, 188);
  //   font-size: 14px;
  //   line-height: 40px;
  //   font-weight: 500;
  //   border-radius: 5px;
  //   height: 22px;
  //   display: flex;
  //   align-items: center;
  //   min-width: max-content;
  // }
  
}
.wy-analytics-contact-reasons-detail-metric-analysis-transcripts {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;

  .wy-analytics-transcript-search-expand {
    // width: calc(100vw - 451px);
  }

  .advanced-search-icon {
    position: relative;
    margin-left: -26px;
    cursor: pointer;
    background-image: url('../../assets/icons/icon_transcripts_advanced_search.svg');
    background-size: 68%;
    width: 24px;
    height: 18px;
    border-radius: 4px;
    background-repeat: no-repeat;
  }

  .transcript-panel-wrapper {
    margin-top: 20px;
    border: 1px solid #ebeef5;

    .transcript-header {
      font-weight: 500;
      font-size: 18px;
      border-bottom: 1px solid #ebeef5;
      padding: 14px 20px;
      cursor: default;
    }

    .transcript-body {
      padding: 14px 20px;

      .search-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 30px;
        max-width: 570px;
        margin: 10px 0px;
        padding-bottom: 30px;

        .search-input-wrapper {
          display: flex;
          align-items: center;

          border: 1px solid #c9cccf;
          border-radius: 30px;
          
        }
        .footer {
          display: flex;
          justify-content: space-between;
          .actions {
            display: flex;
          }
          .actions-btn {
            padding: 10px 16px;
            color: #202223;
            border: 1px solid #CAD2DA;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: normal;
            font-size: 14px;
          }
          .reset {
            border: none;
            margin-left: -14px;
          }
          .clear-btn {
            position: relative;
            font-size: 14px;
            font-weight: normal;
            margin-right: 14px;
            color: var(--site-button-cancel-btn-primary-color);
            border: 0px solid var(--site-button-cancel-btn-primary-border-color);
            padding: 0px;
            .char {
              margin-left: auto;
            }
          }

          .apply-btn {
            position: relative;
            color: var(--site-font-chart-color);
            background: var(--site-button-primary-btn-background-primary-color);
            color: var(--site-button-primary-btn-text-primary-color);
            border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
            border-radius: 4px;
            width: 80px;
          }
          .apply-btn:hover {
            border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
            background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
            border-radius: 5px;
            color: var(--site-button-primary-btn-text-primary-color) !important;
          }
          .apply-btn:active {
            background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
          }
          .apply-btn:focus {
            border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
            // background-color: unset;
            border-radius: 5px;
            color: var(--site-button-primary-btn-text-primary-color) !important;
          }
          .disabled {
            background: #E4E5E7;
            color: #C9CCCF;
          }
        }

        .search-input-option {
          &:hover {
            background-color: #f5f7fa;
          }
        }

        .search-input-field {
          border: none !important;
          &:hover {
            background-color: #f5f7fa;
            border-radius: 30px;
          }

          flex: 1 1;
          padding-left: 10px;

          height: 30px;
          min-width: 548px !important;
          display: flex;
          align-items: center;

          .el-input__inner {
            border: none !important;
            outline: none !important;
            background-color: transparent !important;
            padding-left: 25px;
            padding-right: 60px !important;
          }

          .el-input__inner::placeholder {
            color: #828e9a;
          }

          .search-icon {
            background-image: url('../../assets/icons/icon_search.svg');
            background-size: 70%;
            background-repeat: no-repeat;
            background-position-y: 6px;
            background-position-x: 8px;
            height: 25px;
            width: 25px;
            filter: invert(0.5);
            font-size: 0px; // remove the text
          }

          .el-input__suffix {
            display: flex;
            align-items: center;
            .el-input {
              display: flex;
              align-items: center;
              border-left: 1px solid #c9cccf;
              height: 30px;
            }
          }
        }

        .el-tooltip-wrapper {
          position: relative;
          left: -28px;
          .search-input-field-clear {
            background-image: url('../../assets/icons/icon_close.svg');
            background-size: 90%;
            background-repeat: no-repeat;
            cursor: pointer;
            font-size: 0px;
            width: 20px;
            height: 20px;
            margin-top: 1px;
          }
        }
      }

      .transcript-filters-wrapper {
        display: flex;
        align-items: center;
        width: max-content;
        gap: 10px;
      }

      .saved-transcript-wrapper {
        padding-right: 10px;
        border-right: 1px solid #c9cccf;
      }
      .view-saved-transcript {
        display: flex;
        align-items: center;
        gap: 2px;

        white-space: nowrap;
        border: 1px solid #c9cccf;
        padding: 6px 14px;
        border-radius: 30px;
        cursor: pointer;
        color: var(--site-font-tertiary-color);
        &:hover {
          background-color: #f4f6f8;
        }
        &.selected {
          background-color: #e8f1ff;
          border: 1px solid #106fbc;
        }

        .golden-star-icon {
          background-image: url('../../assets/icons/icon_golden_star.svg');
          float: left;
          background-size: 82%;
          background-repeat: no-repeat;
          height: 18px;
          width: 18px;
          position: relative;
          background-position-x: 0px;
          background-position-y: 2px;
        }
      }

      .filter-dropdown-wrapper {
        flex: 2 1;

        display: flex;
        align-items: center;
      }

      .dropdown-element {
        margin-right: 10px;
        border: 1px solid #c9cccf;
        padding: 6px 14px;
        border-radius: 30px;
        cursor: pointer;

        // active
        &.active {
          border: 1px solid #1a55ad;
          background-color: white;
        }

        &.selected {
          border: 1px solid #1a55ad;
          background-color: #e8f1ff;
        }

        &:hover {
          background-color: #f4f6f8;
        }
      }

      .dropdown-title {
        font-weight: 400;
        display: flex;
        align-items: center;
        gap: 4px;
        color: var(--site-font-tertiary-color);
      }

      .arrow-up {
        background-image: url('../../assets/icons/icon_chevron_up.svg');
        height: 20px;
        width: 20px;
      }

      .arrow-down {
        background-image: url('../../assets/icons/icon_chevron_down.svg');
        height: 20px;
        width: 20px;
      }

      .remove {
        background-image: url('../../assets/icons/icon_blue_close.svg');
        background-repeat: no-repeat;
        background-size: 70%;
        background-position: center;
        height: 20px;
        width: 20px;
      }
    }
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: var(--site-font-tertiary-color) !important;
  }

  // search dropdown
  .el-select .el-input__inner {
    height: 32px !important;
    padding-left: 10px !important;
    border: none !important;
    border-left: 1px solid #c9cccf !important;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .el-select .el-input__icon {
    line-height: 25px !important;
  }

  .wy-analytics-transcript-search-details .summary-icon {
    left: 16px;
  }
}

.contact-reasons-picker-dropdown {
  .el-select-dropdown__item {
    font-size: 14px;
  }
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    display: block !important;
  }

  .el-select-dropdown__list {
    padding: 5px !important;
    .el-select-dropdown__item {
      color: var(--site-font-tertiary-color) !important;
      font-weight: 400;
      font-size: 14.22px;
      border-radius: 4px;
    }
    .el-select-dropdown__item.selected {
      color: var(--site-font-tertiary-color) !important;
      font-weight: 400 !important;
      background: #e8f1ff;
    }
  }
}

.dropdown-content-wrapper {
  width: 446px;
  border-radius: 10px;
}

.dropdown-content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 350;
  font-size: 20px;
  padding: 18px;
  margin-top: -10px;
  border-bottom: 1px solid #cad2da;
  color: var(--site-font-secondary-color);

  .close-icon {
    background-image: var(--icon_close_popup);
    background-repeat: no-repeat;
    height: 30px;
    background-position-y: -3px;
    cursor: pointer;
    &:hover {
      background-color: white;
    }
  }
}
.dropdown-content-checkbox-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 20px;
}
.dropdown-content-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;
  padding: 8px 4px;

  .dropdown-content-label {
    font-size: 14px;
    color: var(--site-font-tertiary-color) !important;
  }

  .flex-signal {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .signal-icon {
    height: 20px;
    width: 20px;
  }

  // match the checkbox style
  .el-checkbox__inner {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }

  // match selected checkbox style
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }

  // match checkbox centering
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  //remove hover
  .el-checkbox__inner:hover {
    -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
    box-shadow: var(--primary-checkbox-button-hover-box-shadow);
  }
}

.dropdown-content-label {
  font-size: 14px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;
  color: var(--site-font-tertiary-color) !important;
}

.dropdown-content-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px;
  padding-bottom: 4px;
  border-top: 1px solid #cad2da;

  .btn-wrapper {
    display: flex;
  }

  .btn {
    padding: 10px 16px;
    color: var(--site-button-cancel-btn-primary-color) !important;;
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    background: transparent;
    border-radius: 5px;
    height: 17px;
    width: 45px;
    font-size: 14.22px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .btn:hover {
    color: var(--site-button-cancel-btn-primary-color) !important;;
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    background: transparent;
  }
  .apply {
    // background-color: #202223;
    // border: 1px solid #0c2837;
    // color: white;
    margin-left: 10px;
    margin-right: 13px;
    background: var(--site-button-primary-btn-background-primary-color);
    color: var(--site-button-primary-btn-text-primary-color) !important;
    border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
    border-radius: 5px;
    height: 17px;
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14.22px;
  }
  .apply:hover {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .apply:active {
    background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
  }
  .apply:focus {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .reset {
    border: none;
    color: #106fbc;
    margin-left: -15px;
    height: 17px;
    width: 74px;
    &:hover {
      color: #106fbc;
    }
  }
}
</style>
